import WifiOffIcon from '@mui/icons-material/WifiOff';
import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import { Tracker } from '../../utils/tracker';
import ResponsibleModal from '../ResponsibleModal';

export const NetworkDisconnectionModal = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showOfflineModal, setShowOfflineModal] = useState(false);
  // Network status monitoring
  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowOfflineModal(false);
      // Emit metric when network is reconnected
      Tracker.getInstance().track(Tracker.EVENTS.NETWORK_RECONNECTED);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowOfflineModal(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Initial check
    setIsOnline(navigator.onLine);
    setShowOfflineModal(!navigator.onLine);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleRetryConnection = () => {
    // This will trigger a network check
    if (navigator.onLine) {
      setIsOnline(true);
      setShowOfflineModal(false);
      // Emit metric when network is reconnected via retry button
      Tracker.getInstance().track(Tracker.EVENTS.NETWORK_RECONNECTED, {
        source: 'retry_button',
      });
    }
  };
  {
    /* Network Disconnection Modal */
  }
  return (
    <ResponsibleModal
      open={showOfflineModal}
      onClose={() => {}}
      closeDisabled={true}
      title="Network Connection Lost"
      containerStyle={{ zIndex: 1400 }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          py: 3,
        }}
      >
        <WifiOffIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
        <Typography variant="h6" align="center" gutterBottom>
          You are currently offline
        </Typography>
        <Typography
          variant="body1"
          align="center"
          color="text.secondary"
          paragraph
        >
          Please check your internet connection and try again.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleRetryConnection}
          sx={{ mt: 2 }}
        >
          Retry Connection
        </Button>
      </Box>
    </ResponsibleModal>
  );
};
